module.exports = ['$scope', 'sessionData','$timeout', function($scope, sessionData,$timeout) {

    // $("*").not(".icon-caret-down").on("click", function (e) {
    //           if (!$(e.target).is(".icon-caret-down,.hmhs-icon,.disable-model .ng-binding,.primary-header .ng-binding,.tooltipClose .icon-x")) {
    //             e.stopPropagation();
    //           }
    //         });
}];


